import { useMutation } from 'react-query';
import { z } from 'zod';

import Api from '../../api/api';

import { RolesDTO } from './useGetAllRoles';

export type UserCreateDTO = {
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  country: string;
  city: string;
  shortBio: string;
  roles: RolesDTO[];
};

const invitedUserSchema = z.object({
  id: z.string().uuid(),
  username: z.string().nullable(),
  verified: z.boolean(),
  passwordSetupRequired: z.boolean(),
  profileSetupRequired: z.boolean(),
});

export const createUser = async (params: UserCreateDTO) => {
  const [response, bodyOrError] = await Api.post('users/invite', params);

  if (!response.ok) {
    throw bodyOrError;
  }

  const body: unknown = bodyOrError;
  return invitedUserSchema.parse(body);
};

export const useCreateUser = () => useMutation('createUser', createUser);
